<template>
  <div>
    <h1>New Leave Requests</h1>

    <b-row align-h="end" class="mb-2" v-if="isLeave()">
      <b-col cols="auto" class="ml-auto">
          <b-button pill variant="outline-primary" @click="download">
              Download All Leave Requests
          </b-button>  
      </b-col>
    </b-row>    
  
    <b-table hover small responsive show-empty
      :fields="fields"
      :items="requests"
      :busy="isLoading">
      <template #table-caption></template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

      <template v-slot:empty="scope">
        <p>No leave requests found.</p>
      </template>

      <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
          <strong>Loading, Please Wait...</strong>
      </div>        

    </b-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import axiosRetry from 'axios-retry';
  import fileDownload  from 'js-file-download'
  import pageTitle from '@/mixins/pageTitle'
  import {roleService} from "@/mixins/roleService";

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
    title: 'New Leave Request',
    data: () => ({
      fields: [
        {key: 'division', sortable: true, label: 'Division'},
        {key: 'employeeId', sortable: true, label: 'EIN'},
        {key: 'employeeName', sortable: true, label: 'Employee Name'},
        {key: 'statusLastDateTime', sortable: true, label: 'Request Received'},
        {key: 'lastUpdatedDateTime', sortable: true, label: 'Last Updated Date'},
        {key: 'leaveType', sortable: true, label: 'Type of Leave'},
        {key: 'workStatus', sortable: true, label: 'Work Status'},
        {key: 'anticipatedStartDate', sortable: true, label: 'Start Date'},
        {key: 'endDate', sortable: true, label: 'End Date'},
      ],
      isLoading: false,
      requests: [],
    }),

    watch: {
      requests() {
        this.isLoading = false
      },
    },
    mixins: [
      pageTitle,
      roleService
    ],
    created () {
      this.initialize()
    },

    methods: {
      fetchRequests(type) {
          this.isLoading = true;
          let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/request/leaveRequests/${type}`          
          axios.get(fullUrl)
            .then(response => {
                this.requests = response.data;
                this.isLoading = false;
            })
      },

      initialize () {
        this.fetchRequests('new')
      },

      download() {
        let requestConfig = {
          responseType: 'blob'       
        }

        axios.get(`${process.env.VUE_APP_API_BASE_URL}/export/bytype/10`, requestConfig)
            .then(response => {
                fileDownload(response.data, 'leave-requests.xlsx')
            })
      }      
    }
  }
</script>